import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Star } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-blue-400 mb-4">
              ApprentCal
            </h3>
            <p className="text-gray-300 text-sm mb-4">
              Professional Electrical Testing & Calibration Laboratory
            </p>
            <div className="flex items-center gap-2 mb-2">
              <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              <span className="text-lg font-semibold">{companyInfo.rating}</span>
              <span className="text-sm text-gray-400">({companyInfo.reviewCount} Reviews)</span>
            </div>
            <p className="text-xs text-gray-400 mt-4">
              Owned by: {companyInfo.owner}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-blue-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-blue-400">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                <div className="text-sm text-gray-300">
                  <p>{companyInfo.address.line1}</p>
                  <p>{companyInfo.address.city}, {companyInfo.address.state}</p>
                  <p>{companyInfo.address.pincode}, {companyInfo.address.country}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-blue-400" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm text-gray-300 hover:text-blue-400 transition-colors">
                  {companyInfo.phone}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-blue-400" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm text-gray-300 hover:text-blue-400 transition-colors">
                  {companyInfo.email}
                </a>
              </div>
            </div>
          </div>

          {/* Working Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-blue-400">Working Hours</h4>
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
              <div className="text-sm text-gray-300">
                <p className="font-medium">Monday - Saturday</p>
                <p>9:00 AM - 6:00 PM</p>
                <p className="mt-2 text-yellow-400">Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} ApprentCal Testing & Calibration Laboratory. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;